import { Dialog, DialogContent } from "@/components/ui/dialog";
import { FilePublishButton } from "@/panes/file-record-detail/FilePublishButton";
import type { FileRecord } from "@cohesive/api-client";

export function PublishFileRecordDialog({
  record,
  onClose,
  onSuccess,
}: {
  record: FileRecord;
  onClose: () => void;
  onSuccess: () => void;
}) {
  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent className="w-[360px] max-w-[calc(100vw-2rem)] gap-0 border dark:border-white/[0.08] p-2 sm:max-w-[360px]">
        <FilePublishButton
          record={record}
          embeddedPanel
          onEmbeddedClose={onClose}
          onEmbeddedSuccess={onSuccess}
        />
      </DialogContent>
    </Dialog>
  );
}
